module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/sniffspot-logo-app-802.c6163a1c27cc5c2e.png"+" 802w",
        images: [{path: "https://static.sniffspot.com/packs/img/sniffspot-logo-app-802.c6163a1c27cc5c2e.png",width: 802,height: 149}],
        src: "https://static.sniffspot.com/packs/img/sniffspot-logo-app-802.c6163a1c27cc5c2e.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/sniffspot-logo-app-802.c6163a1c27cc5c2e.png"},
        
        width: 802,
        height: 149
      }